import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBytes, FctValue } from '../../../../Fct/generics';
export var SafeTransferFrom = createPlugin({
    protocol: 'ERC1155',
    type: 'ACTION',
    method: 'safeTransferFrom',
    supportedContracts: undefined,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'erc1155', isPreview: true, }),
                methodParams: {
                    from: new FctAddress({ isPreview: true, }),
                    to: new FctAddress({ isPreview: true, }),
                    id: new FctValue({}),
                    amount: new FctValue({}),
                    data: new FctBytes({ readonly: true }),
                },
            },
            output: {},
        });
    },
    initParams: {
        methodParams: { data: '0x' },
    },
    requiredApprovals: function (params, _chainId, _walletAddress, vaultAddress) {
        var to = params.to, methodParams = params.methodParams;
        var from = methodParams.from.value;
        if (!vaultAddress || (typeof from === 'string' && vaultAddress.toLowerCase() === from.toLowerCase()))
            return [];
        return [
            {
                to: to.value,
                from: from,
                params: { operator: vaultAddress, approved: 'true', ids: [methodParams.id.value] },
                method: 'setApprovalForAll',
                protocol: 'ERC1155',
            },
        ];
    },
});
